import { webConstants } from "@payping/utils/platformConstants";
import { matchPath, useLocation } from "react-router-dom";

export function useSelectedTab(): string {
  const location = useLocation();

  const matchedRoute = Object.values(webConstants.DashboardRoutes).find((microPaths) => {
    const matchedPath = matchPath({ end: false, path: microPaths.root }, location.pathname);
    return Boolean(matchedPath);
  });

  const selectedPath = matchedRoute?.root || location.pathname;
  return selectedPath;
}
